import { createFileRoute } from "@tanstack/react-router";
import AdminUserOrganizationsPendingPage from "@/pages/admin/users/detail/pending";
import { useUsersPermissions } from "@/pages/admin/users";

export const Route = createFileRoute("/app/admin/users/$userId/pending")({
  component: RouteComponent,
});

function RouteComponent() {
  const { userId } = Route.useParams();
  const { userCanEditAllRequests, userCanViewAllRequests, userCanViewAllUsers } = useUsersPermissions();

  return (
    <AdminUserOrganizationsPendingPage
      subjectUserId={Number(userId)}
      userCanEditAllRequests={userCanEditAllRequests}
      userCanViewAllRequests={userCanViewAllRequests}
      userCanViewAllUsers={userCanViewAllUsers}
    />
  );
}
